import { render } from "./BannerDetailBannerItem.vue?vue&type=template&id=b142c006&scoped=true&ts=true"
import script from "./BannerDetailBannerItem.vue?vue&type=script&lang=ts"
export * from "./BannerDetailBannerItem.vue?vue&type=script&lang=ts"

import "./BannerDetailBannerItem.vue?vue&type=style&index=0&id=b142c006&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b142c006"]])

export default __exports__